module.exports = __webpack_public_path__ + "images/company-placeholder.a37e2129.png";